'use strict';

module.exports = (app) => app.directive('loadingIndicator',  /* @ngInject */ function() {
    return {
        restrict: 'EA',
        scope: {
            isLoading: '=',
			loadingMessage: '='
        },
        template: '<div ng-show="isLoading" id="overlay"><img src="img/loadingAnimation.gif"><span ng-if="loadingMessage">{{loadingMessage}}</span></div>'
    };
})
